import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Preview from 'vue-photo-preview'
import VueLazyload from 'vue-lazyload'

import 'vue-photo-preview/dist/skin.css'

Vue.use(VueLazyload)
Vue.use(Preview)
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
